<template>
  <div>
    <span class="sec-title">{{ $t('diagnostic.clusters.title') }}</span>
    <span class="sec-description" v-html="$t('diagnostic.clusters.description_title') + '<br>' + $t('diagnostic.clusters.description_text') + '<br>' + $t('diagnostic.clusters.description_source')"></span>

    <table class="sales-table" v-if="salesWeek" cellspacing="0" cellpadding="0">
      <thead>
        <tr>
          <th class="hide"></th>
          <th class="vertical">{{ $t('diagnostic.clusters.workdays') }}</th>
          <th class="vertical">{{ $t('diagnostic.clusters.weekend') }}</th>
        </tr>
        <tr class="sales-row">
          <th class="vertical">{{ $t('diagnostic.clusters.sales_weight') }}</th>
          <th v-if="salesWeek">{{ salesWeek }}%</th>
          <th v-else>-</th>
          <th v-if="salesWeekend">{{ salesWeekend }}%</th>
          <th v-else>-</th>
        </tr>
      </thead>
    </table>

    <table
      class="cluster week"
      :class="{ changed: change }"
      v-if="clusterData"
      cellspacing="0"
      cellpadding="0"
    >
      <thead>
        <tr>
          <th colspan="2" class=""></th>
          <th>{{ $t('diagnostic.clusters.workdays') }}</th>
          <th>{{ $t('diagnostic.clusters.weekend') }}</th>
          <th rowspan="2">{{ $t('diagnostic.clusters.main_daypart') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td rowspan="2" class="vertical">{{ $t('diagnostic.clusters.convenience') }}</td>
          <td class="label">{{ $t('diagnostic.clusters.workers') }}</td>
          <td class="editable">
            <input
              min="0"
              v-model="clusterData[1].week"
              :class="{ wrong: clusterData[1].week > 100 }"
              type="number"
            />
            <span class="suffix">%</span>
          </td>
          <td class="editable">
            <input
              min="0"
              v-model="clusterData[1].weekend"
              :class="{ wrong: clusterData[1].weekend > 100 }"
              type="number"
            />
            <span class="suffix">%</span>
          </td>
          <td class="editable">
            <select v-model="clusterData[1].daypart">
              <option value="manana">{{ $t('time.morning') }}</option>
              <option value="comida">{{ $t('time.lunch') }}</option>
              <option value="tarde">{{ $t('time.afternoon') }}</option>
              <option value="cena">{{ $t('time.evening') }}</option>
              <option value="noche">{{ $t('time.night') }}</option>
              <option value="mananatarde">{{ $t('time.morning_afternoon') }}</option>
              <option value="comidacena">{{ $t('time.lunch_evening') }}</option>
              <option value="allday">{{ $t('time.all_day') }}</option>
            </select>
          </td>
        </tr>
        <tr class="separator">
          <td class="label">{{ $t('diagnostic.clusters.students') }}</td>
          <td class="editable">
            <input
              min="0"
              v-model="clusterData[2].week"
              :class="{ wrong: clusterData[2].week > 100 }"
              type="number"
            />
            <span class="suffix">%</span>
          </td>
          <td class="editable">
            <input
              min="0"
              v-model="clusterData[2].weekend"
              :class="{ wrong: clusterData[2].weekend > 100 }"
              type="number"
            />
            <span class="suffix">%</span>
          </td>
          <td class="editable">
            <select v-model="clusterData[2].daypart">
              <option value="manana">{{ $t('time.morning') }}</option>
              <option value="comida">{{ $t('time.lunch') }}</option>
              <option value="tarde">{{ $t('time.afternoon') }}</option>
              <option value="cena">{{ $t('time.evening') }}</option>
              <option value="noche">{{ $t('time.night') }}</option>
              <option value="mananatarde">{{ $t('time.morning_afternoon') }}</option>
              <option value="comidacena">{{ $t('time.lunch_evening') }}</option>
              <option value="allday">{{ $t('time.all_day') }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td rowspan="4" class="vertical">OCIO</td>
          <td class="label">{{ $t('diagnostic.clusters.families') }}</td>
          <td class="editable">
            <input
              min="0"
              v-model="clusterData[3].week"
              :class="{ wrong: clusterData[3].week > 100 }"
              type="number"
            />
            <span class="suffix">%</span>
          </td>
          <td class="editable">
            <input
              min="0"
              v-model="clusterData[3].weekend"
              :class="{ wrong: clusterData[3].weekend > 100 }"
              type="number"
            />
            <span class="suffix">%</span>
          </td>
          <td class="editable">
            <select v-model="clusterData[3].daypart">
              <option value="manana">{{ $t('time.morning') }}</option>
              <option value="comida">{{ $t('time.lunch') }}</option>
              <option value="tarde">{{ $t('time.afternoon') }}</option>
              <option value="cena">{{ $t('time.evening') }}</option>
              <option value="noche">{{ $t('time.night') }}</option>
              <option value="mananatarde">{{ $t('time.morning_afternoon') }}</option>
              <option value="comidacena">{{ $t('time.lunch_evening') }}</option>
              <option value="allday">{{ $t('time.all_day') }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td class="label">{{ $t('diagnostic.clusters.couples_friends') }}</td>
          <td class="editable">
            <input
              min="0"
              v-model="clusterData[4].week"
              :class="{ wrong: clusterData[4].week > 100 }"
              type="number"
            />
            <span class="suffix">%</span>
          </td>
          <td class="editable">
            <input
              min="0"
              v-model="clusterData[4].weekend"
              :class="{ wrong: clusterData[4].weekend > 100 }"
              type="number"
            />
            <span class="suffix">%</span>
          </td>
          <td class="editable">
            <select v-model="clusterData[4].daypart">
              <option value="manana">{{ $t('time.morning') }}</option>
              <option value="comida">{{ $t('time.lunch') }}</option>
              <option value="tarde">{{ $t('time.afternoon') }}</option>
              <option value="cena">{{ $t('time.evening') }}</option>
              <option value="noche">{{ $t('time.night') }}</option>
              <option value="mananatarde">{{ $t('time.morning_afternoon') }}</option>
              <option value="comidacena">{{ $t('time.lunch_evening') }}</option>
              <option value="allday">{{ $t('time.all_day') }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td class="label">{{ $t('diagnostic.clusters.groups') }}</td>
          <td class="editable">
            <input
              min="0"
              v-model="clusterData[5].week"
              :class="{ wrong: clusterData[5].week > 100 }"
              type="number"
            />
            <span class="suffix">%</span>
          </td>
          <td class="editable">
            <input
              min="0"
              v-model="clusterData[5].weekend"
              :class="{ wrong: clusterData[5].weekend > 100 }"
              type="number"
            />
            <span class="suffix">%</span>
          </td>
          <td class="editable">
            <select v-model="clusterData[5].daypart">
              <option value="manana">{{ $t('time.morning') }}</option>
              <option value="comida">{{ $t('time.lunch') }}</option>
              <option value="tarde">{{ $t('time.afternoon') }}</option>
              <option value="cena">{{ $t('time.evening') }}</option>
              <option value="noche">{{ $t('time.night') }}</option>
              <option value="mananatarde">{{ $t('time.morning_afternoon') }}</option>
              <option value="comidacena">{{ $t('time.lunch_evening') }}</option>
              <option value="allday">{{ $t('time.all_day') }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td class="label">{{ $t('diagnostic.clusters.alone') }}</td>
          <td class="editable">
            <input
              min="0"
              v-model="clusterData[6].week"
              :class="{ wrong: clusterData[6].week > 100 }"
              type="number"
            />
            <span class="suffix">%</span>
          </td>
          <td class="editable">
            <input
              min="0"
              v-model="clusterData[6].weekend"
              :class="{ wrong: clusterData[6].weekend > 100 }"
              type="number"
            />
            <span class="suffix">%</span>
          </td>
          <td class="editable">
            <select v-model="clusterData[6].daypart">
              <option value="manana">{{ $t('time.morning') }}</option>
              <option value="comida">{{ $t('time.lunch') }}</option>
              <option value="tarde">{{ $t('time.afternoon') }}</option>
              <option value="cena">{{ $t('time.evening') }}</option>
              <option value="noche">{{ $t('time.night') }}</option>
              <option value="mananatarde">{{ $t('time.morning_afternoon') }}</option>
              <option value="comidacena">{{ $t('time.lunch_evening') }}</option>
              <option value="allday">{{ $t('time.all_day') }}</option>
            </select>
          </td>
        </tr>
        <tr class="summary">
          <td class="hide"></td>
          <td>{{ $t('diagnostic.clusters.total') }}</td>
          <td :class="{ wrong: Math.round(weekResult.week) != 100 }">
            {{ parseInt(weekResult.week) }}%
          </td>
          <td :class="{ wrong: Math.round(weekResult.weekend) != 100 }">
            {{ parseInt(weekResult.weekend) }}%
          </td>
          <td class="hide"></td>
        </tr>
      </tbody>
    </table>

    <div :class="{ hidden: !change }" @click="save()" class="save no-print">
      {{ $t("general.save_changes") }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      clusterData: "",

      change: false,

      load: true
    };
  },
  computed: {
    selectedLocation() {
      return this.$store.getters["locations/getSelectedLocation"];
    },

    cluster() {
      if (this.$store.getters["locations/getCluster"].length != 0) {
        return (this.clusterData = this.$store.getters["locations/getCluster"]);
      } else {
        return (this.clusterData = {
          "1": { cluster_id: "1", week: "", weekend: "", daypart: "" },
          "2": { cluster_id: "2", week: "", weekend: "", daypart: "" },
          "3": { cluster_id: "3", week: "", weekend: "", daypart: "" },
          "4": { cluster_id: "4", week: "", weekend: "", daypart: "" },
          "5": { cluster_id: "5", week: "", weekend: "", daypart: "" },
          "6": { cluster_id: "6", week: "", weekend: "", daypart: "" }
        });
      }
    },

    sales() {
      if (this.$store.getters["locations/getSales"].length == 0) {
        this.$store.dispatch(
          "locations/loadSales",
          this.$store.getters["locations/getSelectedLocation"].id
        );
      } else return JSON.parse(this.$store.getters["locations/getSales"].sales);
    },

    totalSales() {
      var total = 0;
      for (var item in this.sales) {
        total += this.sales[item];
      }
      return total;
    },

    salesWeek() {
      var sales = 0;
      if (this.sales != null) {
        for (var item in this.sales) {
          if (!item.startsWith("sa", 0) && !item.startsWith("do", 0)) {
            sales += this.sales[item];
          }
        }
        return Math.round((sales / this.totalSales) * 100);
      } else return false;
    },

    salesWeekend() {
      var sales = 0;
      if (this.sales != null) {
        for (var item in this.sales) {
          if (item.startsWith("sa", 0) || item.startsWith("do", 0)) {
            sales += this.sales[item];
          }
        }
        return Math.round((sales / this.totalSales) * 100);
      } else return false;
    },

    weekResult() {
      var result = { week: 0, weekend: 0 };

      for (var i = 0; i < Object.keys(this.clusterData).length; i++) {
        for (
          var j = 0;
          j <
          Object.keys(this.clusterData[Object.keys(this.clusterData)[i]])
            .length;
          j++
        ) {
          var group = Object.keys(this.clusterData)[i];
          var time = Object.keys(this.clusterData[group])[j];
          var item = this.clusterData[group][time];

          if (time == "daypart") {
            break;
          } else if (item != "") {
            result[time] += parseInt(item);
          }
        }
      }
      return result;
    }
  },
  methods: {
    save() {
      var aData = {};
      aData.data = this.clusterData;
      aData.restaurant_id = this.$store.getters[
        "locations/getSelectedLocation"
      ].id;
      var self = this;
      this.$store.dispatch("locations/updateCluster", aData).then(function() {
        self.change = false;
      });
    },

    checkChangesBeforeExit: function() {
      if (this.change) {
        return false;
      } else return true;
    }
  },
  watch: {
    clusterData: {
      handler() {
        if (this.load) {
          this.load = false;
        } else {
          this.change = true;
        }
      },
      deep: true
    },

    selectedLocation() {
      if (this.selectedLocation == undefined) {
        this.$store.getters["locations/getSelectedLocation"];
      }
      this.load = true;
      this.change = false;
      var self = this;
      this.$store.dispatch(
        "locations/loadSales",
        this.$store.getters["locations/getSelectedLocation"].id
      );
      this.$store
        .dispatch(
          "locations/loadCluster",
          this.$store.getters["locations/getSelectedLocation"].id
        )
        .then(function() {
          self.cluster;
        });
    }
  },
  created() {
    var self = this;
    this.$store.dispatch(
      "locations/loadSales",
      this.$store.getters["locations/getSelectedLocation"].id
    );
    this.$store
      .dispatch(
        "locations/loadCluster",
        this.$store.getters["locations/getSelectedLocation"].id
      )
      .then(function() {
        self.cluster;
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.sec-title {
  background: var(--main_color);
  color: var(--dark_color);
  display: inline-block;
  text-align: center;
  font-size: 19px;
  font-family: Speedee-Bold;
  margin: 15px 0;
  padding: 0px 10px;
  margin-top: 30px;
  margin-bottom: 10px;
  z-index: 1;
}

.sec-description {
  display: block;
  color: #999;
  margin-bottom: 40px;
}

/* GENERIC */
.wrong {
  background-color: #ffa3a3 !important;
  color: #d42525 !important;
}

/* TABLE STYLES */

.sales-table {
  margin: 0 auto;
  width: 50%;
  margin-bottom: 20px;

  tr {
    border-bottom: 1px solid var(--main_color);
    border-right: 1px solid var(--main_color);
  }

  th {
    background-color: transparent;
    border-bottom: 1px solid var(--main_color);
    border-right: 1px solid var(--main_color);

    height: 50px;
    text-transform: uppercase;
    padding: 0px 10px;

    &.vertical {
      //   writing-mode: vertical-lr;
      //transform: rotate(-40deg);
      width: fit-content;
      padding: 0px 2px;
      background-color: var(--main_color);
      border-bottom-color: #fff;
      color: #fff;
    }
  }
}

.cluster {
  margin: 0 auto;
  border-color: white;
  width: 95%;

  &.weekend {
    margin-top: 40px;
  }

  .hide {
    visibility: hidden !important;
    opacity: 0 !important;
  }

  thead {
    tr {
      &.sales-row {
        //background-color: black;
        //color: white;

        th {
          background-color: transparent;
        }
      }
      th {
        background-color: transparent;
        border-bottom: 1px solid var(--main_color);
        height: 50px;
        text-transform: uppercase;
        padding: 0px 10px;
      }
    }
  }

  tr {
    //background-color: rgba(255,255,255,0.5);
    height: 50px;

    &.separator {
      td {
        border-bottom: 1px solid #777;
      }
    }
  }

  tbody {
    //background-color: var(--main_color);
    tr:nth-child(odd) {
      //background-color: rgba(255,255,255,0.7);

      .editable {
        //background-color: rgba(255,255,255,1);
      }
    }
  }

  td {
    text-transform: uppercase;
    font-weight: bold;
    padding: 0px 5px;
    text-align: left;
    width: 10%;
    text-align: center;
    border-bottom: 1px solid #ddd;
    background-color: rgba(255, 255, 255, 0.7);

    &.label {
      text-align: left;
      padding-left: 10px;
      font-weight: lighter;
    }

    &.vertical {
      //   writing-mode: vertical-lr;
      //transform: rotate(-40deg);
      width: fit-content;
      padding: 0px 2px;
      background-color: var(--main_color);
      border-bottom-color: #fff;
      color: #fff;
    }

    .description {
      display: block;
      text-transform: none;
      font-weight: normal;
      font-size: 13px;
    }
  }

  td {
    overflow: hidden;

    &.editable {
      position: relative;
    }

    input {
      height: 40px;
      text-align: center;
      font-size: 17px;
      appearance: textfield;
      width: 100%;
      outline: 0px;
    }

    &:hover {
      input {
        background-color: #eee;
      }
    }

    select {
      font-size: 15px;
      padding: 8px;
      font-weight: lighter;
    }

    .suffix {
      position: absolute;
      left: calc(50% + 8px);
      top: 15px;
      display: inline;
    }
  }

  .summary {
    td {
      background-color: #333;
      color: #fff;
    }
  }
}

.save {
  background-color: #8bc34a;
  width: fit-content;
  margin: 0 auto;
  margin-top: 30px;
  color: white;
  padding: 8px 25px;
  border-radius: 3px;
  font-size: 16px;
  cursor: pointer;
  opacity: 1;
  transition: 0.5s;
  text-transform: uppercase;

  &.hidden {
    display: none;
    opacity: 0;
    height: 0px;
    transition: 0.5s;
  }
}
</style>
